import { createSlice } from "@reduxjs/toolkit";

const numberSlice = createSlice({
  name:"numberSlice",
  initialState:{number:""},
  reducers:{
    set:(state, action)=>{
      state.number = action.payload;
    }
  }
})

export const {set} = numberSlice.actions;
export default numberSlice.reducer;

